import { addMonths, subDays } from "date-fns";
export const getOfferEndDate = ({ acceptedAt, interval, maxUses }) => {
    if (!maxUses) {
        return undefined;
    }
    const numberOfMonthsPromoIsActive = interval === "month" ? maxUses : maxUses * 12;
    const startDate = new Date(acceptedAt !== null && acceptedAt !== void 0 ? acceptedAt : Date.now());
    let endDate = addMonths(startDate, numberOfMonthsPromoIsActive);
    while (endDate.getMonth() - startDate.getMonth() >
        numberOfMonthsPromoIsActive) {
        endDate = subDays(endDate, 1);
    }
    return endDate;
};

// @zapier/upsells@5.0.1 (c64b11b3c)
